import React from 'react'
import AgTechAppDataContext from '@agtech/core/data/AgTechAppDataContext';
import AgTechWebAppContext from '../../Contexts/AgTechWebAppContext';
import AgTechWebNavigationContext from '../../Routing/AgTechWebNavigationContext';
import AgTechWebAppAuthContext from '../../Auth/AgTechWebAuthContext';
import AgTechWebAppErrorBoundary from '../../Contexts/AgTechWebErrorBoundary';
import AgTechWebAppRouter from '../../Routing/AgTechWebAppRouter';
import { AgTechWebApplication } from '../../../../application/AgTechWebApplication';
import { enableDevelopmentFeatures } from '../../Development/AgTechWebAppDevelopment';

const AgTechWebApp = (props: { app: AgTechWebApplication }) => {
    enableDevelopmentFeatures();
    
    return (
        <AgTechWebNavigationContext app={props.app}>
            <AgTechWebAppErrorBoundary>
                <AgTechWebAppAuthContext app={props.app}>
                    <AgTechAppDataContext app={props.app}>
                        <AgTechWebAppContext app={props.app}>
                            <AgTechWebAppRouter app={props.app} />
                        </AgTechWebAppContext>
                    </AgTechAppDataContext>
                </AgTechWebAppAuthContext>
            </AgTechWebAppErrorBoundary>
        </AgTechWebNavigationContext>
    )
}

export default AgTechWebApp;